import { render, staticRenderFns } from "./ErrorVazio.vue?vue&type=template&id=5a98588b&scoped=true"
import script from "./ErrorVazio.vue?vue&type=script&lang=js"
export * from "./ErrorVazio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a98588b",
  null
  
)

export default component.exports